export default "__VITE_ASSET__ad28bf1b__"